import React, { useState } from 'react';
import { Box, IconButton, Tooltip, ThemeProvider, createTheme } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4'; // Moon icon for dark mode
import Brightness7Icon from '@mui/icons-material/Brightness7'; // Sun icon for light mode


const DashboardLayout = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false);

  // Define light and dark themes
  const lightTheme = createTheme({
    palette: {
      mode: 'light',
    },
  });

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
    },
  });

  const currentTheme = darkMode ? darkTheme : lightTheme;

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  return (
    <ThemeProvider theme={currentTheme}>
      <Box display="flex" flexDirection="row" height="100vh">
        {children}
      </Box>
      <Tooltip title={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
        <IconButton
          onClick={toggleTheme}
          sx={{
            position: 'fixed',
            right: 16,
            bottom: 16,
            zIndex: 1000,
            backgroundColor: darkMode ? '#333' : '#fff',
            color: darkMode ? '#fff' : '#333',
            '&:hover': {
              backgroundColor: darkMode ? '#444' : '#f5f5f5',
            },
            borderRadius: '50%', // Make the button circular
            width: 56, // Set width and height for a larger button
            height: 56,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', // Add shadow for a floating effect
          }}
        >
          {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
        </IconButton>
      </Tooltip>
    </ThemeProvider>
  );
};

export default DashboardLayout;
